export default "__VITE_ASSET__By1DTtcE__"